import React from 'react';
import LayoutAdmin from '../../layouts/admin';
import DeviceManagementContent from '../../components/device_management';



const DevicetManagementPage = () => {
  return (
    <LayoutAdmin content={<DeviceManagementContent/>}/>
  );
}

export default DevicetManagementPage;